<template>
  <div class="wxchartBox">
    <div class="wxchart" v-for="(item, index) in serviceList" :key="index" @click="copyWechat(item)">
      <div class="wx-info">
        <img class="wechartimg" :src="item.avatar" alt="客服头像">
        <div class="wxname">{{ item.name }}</div>
      </div>
      <img 
        class="wximg" 
        src="../assets/wximg.png" 
        alt="复制按钮" 
      >
    </div>
    <div class="wechatMark" v-if="wechatMark" @click="closeMask">
      <div class="wechatContent" @click.stop>
        <img class="ercodeImg" :src="ercodeImg" alt="">
        <img class="bottomBox" src="https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/36/4af2c657-533a-4640-9d41-5b27d4637596.png?height=134&width=514&size=58" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WechatService',
  data() {
    return {
      wechatMark: false,
      ercodeImg: ''
    }
  },
  props: {
    serviceList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    async copyWechat(item) {
      // 1. 先校验微信号是否存在（避免空值复制）
      if (!item.wechatId) {
        this.$toast('微信号为空，无法复制');
        return;
      }

      try {
        // 2. 优先判断现代复制 API 是否可用（避免直接走 catch）
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          await navigator.clipboard.writeText(item.wechatId);
          // this.$toast('微信号已复制'); // 补充成功提示（之前缺失）
        } else {
          // 3. 现代 API 不可用，直接走传统复制方法
          this.traditionalCopy(item.wechatId);
          return; // 传统方法已处理提示，无需继续
        }
        // 4. 复制成功后显示遮罩（原有逻辑不变）
        this.wechatMark = true;
        this.ercodeImg = item.ercodeImg;

      } catch (error) {
        // 5. 现代方法失败时，打印错误日志（便于排查具体原因）
        // console.error('安卓端现代复制方法失败：', error);
        // 6. 降级为传统复制方法保底
        const copySuccess = this.traditionalCopy(item.wechatId);
        if (copySuccess) {
          // 传统方法复制成功，再显示遮罩
          this.wechatMark = true;
          this.ercodeImg = item.ercodeImg;
        }
      }
    },

    /**
     * 传统复制方法（安卓端保底）
     * @param {string} text - 要复制的文本
     * @returns {boolean} - 复制是否成功
     */
    traditionalCopy(text) {
      try {
        const input = document.createElement('input');
        // 关键：设置 input 为不可见（避免影响页面布局）
        input.style.position = 'fixed';
        input.style.top = '-999px';
        input.style.left = '-999px';
        input.value = text;
        document.body.appendChild(input);

        // 选中输入框内容（兼容安卓部分浏览器）
        input.select();
        // 部分浏览器需要选中全部内容（增强兼容性）
        input.setSelectionRange(0, text.length);

        // 执行复制（返回布尔值，表示是否成功）
        const success = document.execCommand('copy');
        
        document.body.removeChild(input); // 移除临时元素
        if (success) {
          // this.$toast('微信号已复制');
          return true;
        } else {
          this.$toast('复制失败，请手动复制微信号');
          return false;
        }
      } catch (err) {
        console.error('传统复制方法失败：', err);
        this.$toast('复制失败，请手动复制微信号');
        return false;
      }
    },
    closeMask() {
      this.wechatMark = false
    }
  }
}
</script>

<style scoped lang="scss">
  .wxchartBox{
    width: 100%;
    padding: 0 .04rem 0.1rem 0;
    background: rgba(255, 255, 255, 0.08);
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
    border-radius: 0.16rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .wxchart{
      width: 1.55rem;
      height: 0.4rem;
      background: rgba(255, 255, 255, 0.08);
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.05rem;
      box-sizing: border-box;
      margin-top: 0.1rem;
      margin-left: .04rem;
      box-sizing: border-box;
      div{
        display: flex;
        align-items: center;
        .wechartimg{
          width:.32rem;
          height:.32rem;
          border-radius: 50%;
        }
        .wxname{
          font-size: .11rem;
          color:rgba(255, 255, 255, 1);
          margin-left: .05rem;
        }
      }
      .wximg{
        width:.22rem;
        height:.22rem;
      }
    }
    .wechatMark{
      position: fixed;
      top:0;
      left:0;
      width:100%;
      height:100vh;
      background: rgba(6, 5, 24, 0.4);
      z-index: 2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      backdrop-filter: blur(8px); /* 核心属性：模糊下方内容 */
      -webkit-backdrop-filter: blur(8px);
      .wechatContent{
        width:2.57rem;
        .ercodeImg{
          width:100%;
          height: 3.5rem;
        }
        .bottomBox{
          // color: #fff;
          width:100%;
          height:.67rem;
          margin-top: -.1rem;
          // background: linear-gradient(to right top, rgba(62, 69, 255, 1) 20%, rgba(191, 11, 255, 1));
          // .bottomTitle{

          // }
        }
      }
    }
  }
</style>